package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_04_05_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-04-05")
@Composable
public fun Log_2024_04_05(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Incriminating Notes",
        ogTitle = "Incriminating Notes",
        date = LocalDate(2_024, 4, 5),
        ogDescription = "After defeating the ambushers, the heroes find a note linking the Duke of Brij to the mysterious attacks.",
        ogImage = "ai/2024-04-05.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-47", dateString = "Newgrowth 47")
        Log_2024_04_05_Day_1()
    }
}
